import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _excluded = ["children", "component", "className", "notWide", "wide"],
    _excluded2 = ["children", "notWide", "wide"];
// TODO: remove this component in Currency v2
import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import styles from './LegacyBox.module.less';
var flexColumnValues = ['auto', 0, 1, 2, 3, 4];
var wideFlexColumnValues = ['auto', 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
var justifyFlexValues = ['center', 'flex-end', 'flex-start', 'space-around', 'space-between', 'space-evenly', 'start'];
var wrapValues = ['wrap', 'nowrap'];
var noGutterValues = ['left', 'right', 'both'];
// Default styles and properties
var defaultBoxStyles = {
  columns: 'auto',
  direction: 'row',
  noGutter: undefined,
  justify: 'space-between',
  wrap: 'wrap'
};
/**
 * Generate styles based on the Grid System constraints
 * around breakpoint sizes. Include flexbox, gutter, and
 * margin styles based on columns and breakpoint size.
 */

var getBreakpointStyles = function getBreakpointStyles(breakpoint, options) {
  if (!options) return null;

  var _defaultBoxStyles$opt = _objectSpread(_objectSpread({}, defaultBoxStyles), options),
      columns = _defaultBoxStyles$opt.columns,
      direction = _defaultBoxStyles$opt.direction,
      noGutter = _defaultBoxStyles$opt.noGutter,
      justify = _defaultBoxStyles$opt.justify,
      wrap = _defaultBoxStyles$opt.wrap;

  var boxStyles = [classNames(styles["col-".concat(columns, "-").concat(breakpoint)], styles["flex-direction-".concat(direction, "-").concat(breakpoint)], styles["flex-wrap-".concat(wrap, "-").concat(breakpoint)], styles["justify-content-".concat(justify, "-").concat(breakpoint)])]; // Enable consumers to opt out of the default gutters that are
  // applied to all Boxes.

  var gutters = {
    left: true,
    right: true
  };

  if (noGutter === 'left') {
    gutters.left = false;
  } else if (noGutter === 'right') {
    gutters.right = false;
  } else if (noGutter === 'both') {
    gutters.left = false;
    gutters.right = false;
  }

  if (gutters.left) {
    boxStyles.push(styles["gutter-left-".concat(breakpoint)]);
  }

  if (gutters.right) {
    boxStyles.push(styles["gutter-right-".concat(breakpoint)]);
  }

  return boxStyles;
};
/**
 * `<LegacyBox>` is a simple flexbox layout component that respects NerdWallet breakpoints.
 * It's normally used inside of `<CenteredContainer>`.
 *
 * @deprecated
 */


export var LegacyBox = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      className = props.className,
      _props$notWide = props.notWide,
      notWide = _props$notWide === void 0 ? defaultBoxStyles : _props$notWide,
      _props$wide = props.wide,
      wide = _props$wide === void 0 ? defaultBoxStyles : _props$wide,
      otherProps = _objectWithoutProperties(props, _excluded);

  useDeprecatedComponentWarning({
    component: 'LegacyBox',
    migration: 'Use the new <Stack>, <Columns>, and other layout components.'
  }); // Apply grid system specific styles as well as custom style. Some
  // rules should be applied to every Box by default, regardless of breakpoint.

  var boxStyles = classes('display-flex', 'max-width-100');
  var notWideStyles = getBreakpointStyles('not-wide', notWide);
  var wideStyles = getBreakpointStyles('wide', wide);
  var gridStyles = classNames(boxStyles, notWideStyles, wideStyles, className);
  return /*#__PURE__*/React.createElement(Component, _extends({
    "data-currency": "LegacyBox",
    className: gridStyles,
    ref: ref
  }, otherProps), children);
});
LegacyBox.displayName = 'LegacyBox';

/**
 * See CenteredContainer and the other layout components.
 *
 * @deprecated
 */
export var BoxContainer = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      notWide = props.notWide,
      wide = props.wide,
      otherProps = _objectWithoutProperties(props, _excluded2);

  useDeprecatedComponentWarning({
    component: 'BoxContainer',
    migration: 'Use <CenteredContainer> and other layout components.'
  });
  return /*#__PURE__*/React.createElement(LegacyBox, _extends({
    notWide: _objectSpread({
      noGutter: 'both'
    }, notWide),
    wide: _objectSpread({
      noGutter: 'both'
    }, wide)
  }, otherProps, {
    className: classNames(classes('max-width-container', 'margin-horizontal-auto', 'padding-horizontal-3', 'padding-horizontal-5--wide'), otherProps.className, styles['box-container']),
    ref: ref
  }), children);
});
BoxContainer.displayName = 'BoxContainer';